import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimg from "../../../assets/adobeleftimg.png";
import rightimg from "../../../assets/adoberightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/illustrator-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/illustrator-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/illustrator-benefit-img5.png";
import BenefitsDataImg4 from "../../../assets/illustrator-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/illustrator-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/illustrator-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/illustrator-benefit-img2.png";
import BenefitsDataImg8 from "../../../assets/illustrator-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/illustrator-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/illustratorFun-img1.png";
import FunactivitiesImg2 from "../../../assets/illustratorFun-img2.png";
import FunactivitiesImg3 from "../../../assets/illustratorFun-img3.png";
import FunactivitiesImg4 from "../../../assets/illustratorFun-img4.png";
import FunactivitiesImg5 from "../../../assets/illustratorFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "07",
      description:"Introduction to Graphic Designing- Learn graphic design fundamentals, image sourcing, file formats, and explore online marketplaces to earn money using design skills.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "07",
      description:" Adobe Illustrator Basics- Understand Adobe Illustrator basics, working with shapes, tools, color palettes, and concepts like Mask and Stroke.",
    },
    {
      title: "Module 3",
      activities: "11",
      classes: "08",
      description:" Adobe Illustrator Advanced-  Master advanced Illustrator features like Swatches, Patterns, image tracing, and design creation for logos, business cards, letterheads, and CVs",
    },
];    

  const benefitsData = [
      {
        title: "Graphic Design Fundamentals",
        description: "Build a strong base in design concepts.",
        icon: BenefitsDataImg1,
      },
      {
        title: "principles of Design",
        description: "Learn balance, contrast, alignment, and hierarchy.",
        icon: BenefitsDataImg2,
      },
      {
        title: "Adobe Illustrator Basics",
        description: "Get comfortable with workspace and essential tools.",
        icon: BenefitsDataImg3,
      },
      {
        title: "Advanced Illustrator ",
        description: "Use layers, artboards, and effects like a pro.",
        icon: BenefitsDataImg4,
      },
      {
        title: "Pen, Shape & Type Tools",
        description: "Create precise paths, custom shapes, and stylish text",
        icon: BenefitsDataImg5,
      },
      {
        title: "Color Swatches & Patterns",
        description: "Apply color theory using swatches, gradients, and patterns",
        icon: BenefitsDataImg6,
      },
      {
        title: "CV, Logo & Flyer Design",
        description: "Design personal branding and professional assets.",
        icon: BenefitsDataImg7,
      },
      {
        title: "Image Trace Tool",
        description: "Convert raster images to clean vector artwork.",
        icon: BenefitsDataImg8,
      },
      {
        title: "Live Paint Tool",
        description: "Easily fill shapes and illustrations with color.",
        icon: BenefitsDataImg9,
      },
    ];
    const activitiesData = [
        {
          title: "UI/UX Fundamentals",
          image: FunactivitiesImg1,
        },
        {
          title: "Animations",
          image: FunactivitiesImg2,
        },
        {
          title: "Shapes",
          image: FunactivitiesImg3,
        },
        {
          title: "Logo Designing",
          image: FunactivitiesImg4,
        },
        {
          title: "Business Cards",
          image: FunactivitiesImg5,
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const Illustrator = () => {
  const Illustratorpage = heroContent.illustratorsection;
  return (
    <>
     <GuestNav/>
     <Hero2
        titlePart1={Illustratorpage.titlePart1}
        // titlePart2={adobepage.titlePart2}
        description={Illustratorpage.description}
        buttonText={Illustratorpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Illustrator